<script>
export default {
    name: "Status",
    computed:{
        status_color_icon(){
            if(this.discepline.status.utverzhden){
                var status_color_icon_data = {color:"color: green;",text:"утвержден",icons:"CheckCircleIcon"}
                return status_color_icon_data
            }
            else if(this.discepline.status.nevybran){
                var status_color_icon_data = {color:"color: orange;",text:"не выбран",icons:"AlertCircleIcon"}
                return status_color_icon_data
            }
            else if(this.discepline.status.otklonen){
                var status_color_icon_data = {color:"color: red;",text:"отклонен",icons:"XCircleIcon"}
                return status_color_icon_data
            }
            else if(this.discepline.status.vybran){
                var status_color_icon_data = {color:"color: #0000ff;",text:"выбран",icons:"CheckSquareIcon"}
                return status_color_icon_data
            }
            else if(this.discepline.status.izmenen){
                var status_color_icon_data = {color:"color: #8000ff;",text:"изменен",icons:"EditIcon"}
                return status_color_icon_data
            }
            else if(this.discepline.status.vputi){
                var status_color_icon_data = {color:"color: #8000ff;",text:"В пути",icons:"ChevronsDownIcon"}
                return status_color_icon_data
            }
            else{
                var status_color_icon_data = {color:"color: #666666;",text:"не изучается",icons:"FileMinusIcon"}
                return status_color_icon_data

            }
        }
    }

}
</script>
